import React from "react";
import "./FrontendSkills.css";
import { FaAdn, FaVuejs } from "react-icons/fa";
import { SiTailwindcss } from "react-icons/si";
import {
  DiBootstrap,
  DiCss3,
  DiHtml5,
  DiNodejsSmall,
  DiReact,
} from "react-icons/di";
const FrontendSkills = () => {
  return (
    <div className="container">
      <div className="parent">
        <div className="item">
          <div>
            <DiHtml5></DiHtml5>
          </div>
        </div>
        <div className="item">
          <div>
            <DiCss3></DiCss3>
          </div>
        </div>
        <div className="item">
          <div>
            <DiNodejsSmall></DiNodejsSmall>
          </div>
        </div>
        <div className="item">
          <div>
            <DiBootstrap></DiBootstrap>
          </div>
        </div>
        <div className="item">
          <div>
            <FaVuejs />
          </div>
        </div>
        <div className="item">
          <div>
            <DiReact></DiReact>
          </div>
        </div>
        <div className="item">
          <div>
            <SiTailwindcss />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FrontendSkills;
